import { element } from 'protractor';
import { ConteudoService } from './../../../service/caixa/conteudo.service';
import { CaixaModel } from './../../../model/caixa/caixa.model';
import { CaixaService } from './../../../service/caixa/caixa.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { EventEmitterService } from 'app/service/event-emitter-service';

@Component({
  selector: 'app-relatorio-caixa',
  templateUrl: './relatorio-caixa.component.html',
  styleUrls: ['./relatorio-caixa.component.scss']
})
export class RelatorioCaixaComponent implements OnInit, OnDestroy {
  caixaId;
  deData;
  public caixa = {} as CaixaModel;
  conteudosAny: any[] = [];
  tiposDoc: any[] = [];
  loading = true;
  dateTime;

  constructor(
    private route: ActivatedRoute,
    private caixaService: CaixaService,
    private conteudoService: ConteudoService
  ) {
    this.route.params.subscribe(params => this.caixaId = params['id']);
    this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.caixaId), 'pcdoc');
    this.caixaId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));

    EventEmitterService.get('isPrintPage').emit(true);
   }

  ngOnInit() {
    this.getDadosCaixa(this.caixaId);
    this.getItensCaixa(this.caixaId);
    this.getConteudoCaixa(this.caixaId);
    const date = new Date();
    this.dateTime = date.toLocaleString('pt-BR');
  }

  ngOnDestroy() {
    EventEmitterService.get('isPrintPage').emit(false);
  }

  getDadosCaixa(caixaId) {
    this.caixaService.getCaixaUnica(caixaId).subscribe(data => {
      console.log(data);
      this.caixa = data;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  getConteudoCaixa(caixaId) {
    this.conteudoService.listaItensRelatorio(caixaId).subscribe(data => {
      console.log(data);
      this.tiposDoc = data;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  getItensCaixa (idCaixa) {
    this.conteudoService.listaItens(idCaixa).subscribe(data => {
      this.conteudosAny = data;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/relatorio-caixa/relatorio-caixa.component.ts